export default __webpack_public_path__ + "static/media/rnr-sports-table-15-cn.13ead272.webp";